import { apiGet } from 'vivino-js/apiClient';

export function fetchTastesByWineId({ wineId }) {
  const url = `/api/wines/${wineId}/tastes`;
  return apiGet({ url });
}
